"use client";

import { STEPS } from "@repo/constants/checkout";
import cx from "classnames";
import { useTranslations } from "next-intl";
const Stepper = ({
  activeStepper,
  onStepChange,
  completedSteps
}) => {
  const t = useTranslations("Common");
  return <div className="mb-4 md:max-w-96" data-sentry-component="Stepper" data-sentry-source-file="Stepper.jsx">
      <div className="relative">
        <div className="bg-lightgray absolute top-1/2 z-10 h-0.5 w-full -translate-y-1/2"></div>
        <div className="relative z-20 flex justify-between text-[#929191]">
          {STEPS?.map((step, index) => <div key={index} className="flex items-center bg-white px-3 first:ps-0 last:pe-0">
              <button onClick={() => onStepChange(step.step)} disabled={!completedSteps[step.step]} className={cx("text-sm md:text-base", {
            "text-primarygray": activeStepper === step.step,
            "text-[#388E3C]": completedSteps[step.step],
            "cursor-not-allowed": !completedSteps[step.step]
          })}>
                {t(step.name)}
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default Stepper;